import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'

import CurrencyClass from './../../../../../../../../js/classes/Currency.js'

const ListItem = ({ order, data }) => {
    const [isShowItems, setShowItems] = useState(false),
    handleShowItems = () => {
        setShowItems(!isShowItems)
    }

    return <div className="manager__row-container"> 
        <div className="manager__row">        
            <div className="manager__td">
                <a className="manager__number" href={ `/manager/orders/?ORDER_ID=${ order.ID } `}>
                    № { order.ACCOUNT_NUMBER }
                </a>
                <br />
                <span className="manager__order-id">[{ order.ID }]</span>
                <div className="manager__date-insert">{ moment(order.DATE_INSERT.ISO).format('DD.MM.YYYY HH:mm:ss') }</div>
            </div>
            <div className="manager__td">
                <div className="manager__title">
                    { order.PERSON ? order.PERSON.NAME : null }
                </div>
                
                { data.properties.map((propertyGroup) => {
                    if (propertyGroup.ID == 1 && propertyGroup.PERSON_TYPE_ID == order.PERSON_TYPE_ID) {
                        return order.PROPERTIES.map((property) => {
                            if (propertyGroup._PROPERTIES[property.CODE]) {
                                return <div key={ `order-${ order.ID }-${ propertyGroup.ID }-properties-${ property.ID }` } className="manager__field">
                                    <div className="manager__field-key">
                                        { property.NAME }:
                                    </div>
                                    <div className="manager__field-value" title={ property.VALUE }>
                                        { property.VALUE ? property.VALUE :'- Не указано -' }
                                    </div>
                                </div>
                            }
                            
                            return null
                        })
                    }

                    return null
                }) }
            </div>
            <div className="manager__td">
                <div className="manager__title">
                    «{ order.PAYMENT ? order.PAYMENT.NAME : 'Оплата не найдена' }»
                </div>

                { (order.PAYED) ? 
                    <div className="manager__payed">Оплачено</div> : 
                    <div className="manager__no-payed">Не оплачено</div> 
                }
            </div>
            <div className="manager__td">
                <div className="manager__title">
                    «{ order.DELIVERY ? order.DELIVERY.NAME : 'Доставка не найдена' }»
                </div>

                <div className="manager__field">
                    <div className="manager__field-key">
                        Стоимость: 
                    </div>
                    <div className="manager__field-value" title={ CurrencyClass.format(order.PRICE_DELIVERY) }>
                        { CurrencyClass.format(order.PRICE_DELIVERY) }
                    </div>
                </div>

                { order.TRACKING_NUMBER ? <div className="manager__field">
                    <div className="manager__field-key">
                        Трекномер: 
                    </div>
                    <div className="manager__field-value" title={ order.TRACKING_NUMBER }>
                        { order.TRACKING_NUMBER }
                    </div>
                </div> : null }

                { order.STORE ? <div className="manager__store">
                    <div className="manager__store-label">
                        Пункт выдачи: 
                    </div>
                    <div>
                        <div className="manager__store-title">
                            { order.STORE.TITLE }
                        </div>
                        <div className="manager__store-value">
                            { order.STORE.ADDRESS }
                        </div>
                    </div>
                </div> : null }
            </div>
            <div className="manager__td">
                <div className="manager__field">
                    <div className="manager__field-key">
                        { order.CART.count_format }
                    </div>
                </div>

                <div className="manager__field">
                    <div className="manager__field-key">
                        На сумму (без учёта доставки): 
                    </div>
                    <div className="manager__field-value">
                        { order.CART.summary_format }

                        { (order.CART.discount_summary > 0) ? <><br />Скидка: <strike>-{ order.CART.discount_summary_format }</strike></> : null }
                    </div>
                </div>

                <div className="manager__basket">
                    <span className="manager__basket-show" onClick={ handleShowItems }>Показать товары</span>

                    { isShowItems ? <div className="manager__basket-items">
                        { order.CART.items.map((product) => {
                            return <div key={ `order-${ order.ID }-cart-product-${ product.ID }` } className="manager__basket-item">
                                <a href={ product.DETAIL_PAGE_URL } className="manager__basket-link" target="_blank">
                                    { product.NAME } x <span className="manager__no-wrap">{ product.QUANTITY } шт.</span> = <span className="manager__no-wrap">{ product.SUMMARY_FORMAT }</span>
                                </a>
                            </div>
                        }) }
                    </div> : null }
                </div>
            </div>
            <div className="manager__td">
                <div className="manager__field">
                    <div className="manager__field-key">
                        К оплате: 
                    </div>
                    <div className="manager__field-value" title={ CurrencyClass.format(order.PRICE) }>
                        { CurrencyClass.format(order.PRICE) }
                    </div>
                </div>

                <div className="manager__field">
                    <div className="manager__field-key">
                        Товаров на сумму: 
                    </div>
                    <div className="manager__field-value" title={ order.CART.summary_format }>
                        { order.CART.summary_format }
                    </div>
                </div>

                { (order.CART.coupons.length > 0) ? <div className="manager__field">
                    <div className="manager__field-key">
                        Купоны:
                    </div>

                    { order.CART.coupons.map((coupon, index) => {
                        return <div key={ `order-${ order.ID }-coupon-${ index }` } className="manager__field-value" title={ coupon }>
                            { coupon }
                        </div>
                    }) }
                </div> : null }
            </div>
            <div className="manager__td">
                { order.CANCELED ? 
                <span className="manager__status" style={ { backgroundColor : '#F00000', color: '#FFFFFF' } } title="Отменён">
                    Отменён
                </span>
                : <span className="manager__status" style={ { backgroundColor : order.STATUS ? order.STATUS.COLOR : '#000000' } } title={ order.STATUS ? order.STATUS.NAME : 'Статус не найден' }>
                    { order.STATUS ? order.STATUS.NAME : 'Статус не найден' }
                </span> }
            </div>
        </div>

        { (order.USER_DESCRIPTION) ?
            <div className="manager__description-container"> 
                <div className="manager__description">  
                    <div className="manager__description-label">
                        Комментарий пользователя: 
                    </div>
                    <div className="manager__description-text">
                        { order.USER_DESCRIPTION }
                    </div>
                </div>
            </div>
        : null }
    </div>
}

export default ListItem